const nouns =
{
  "en": [
    'Armour',
    'Barrymore',
    'Cabot',
    'Catholicism',
    'Chihuahua',
    'Christianity',
    'Easter',
    'Frenchman',
    'Lowry',
    'Mayer',
    'Orientalism',
    'Pharaoh',
    'Pueblo',
    'Pullman',
    'Rodeo',
    'Saturday',
    'Sister',
    'Snead',
    'Syrah',
    'Tuesday',
    'Woodward',
    'abbey',
    'absence',
    'absorption',
    'abstinence',
    'absurdity',
    'abundance',
    'acceptance',
    'accessibility',
    'accommodation',
    'accomplice',
    'accountability',
    'accounting',
    'accreditation',
    'accuracy',
    'acquiescence',
    'acreage',
    'actress',
    'actuality',
    'adage',
    'adaptation',
    'adherence',
    'adjustment',
    'adoption',
    'adultery',
    'advancement',
    'advert',
    'advertisement',
    'advertising',
    'advice',
    'aesthetics',
    'affinity',
    'aggression',
    'agriculture',
    'aircraft',
    'airtime',
    'allegation',
    'allegiance',
    'allegory',
    'allergy',
    'allies',
    'alligator',
    'allocation',
    'allotment',
    'altercation',
    'ambulance',
    'ammonia',
    'anatomy',
    'anemia',
    'ankle',
    'announcement',
    'annoyance',
    'annuity',
    'anomaly',
    'anthropology',
    'anxiety',
    'apartheid',
    'apologise',
    'apostle',
    'apparatus',
    'appeasement',
    'appellation',
    'appendix',
    'applause',
    'appointment',
    'appraisal',
    'archery',
    'archipelago',
    'architecture',
    'ardor',
    'arrears',
    'arrow',
    'artisan',
    'artistry',
    'ascent',
    'assembly',
    'assignment',
    'association',
    'asthma',
    'atheism',
    'attacker',
    'attraction',
    'attractiveness',
    'auspices',
    'authority',
    'avarice',
    'aversion',
    'aviation',
    'babbling',
    'backlash',
    'baker',
    'ballet',
    'balls',
    'banjo',
    'baron',
    'barrier',
    'barrister',
    'bases',
    'basin',
    'basis',
    'battery',
    'battling',
    'bedtime',
    'beginner',
    'begun',
    'bending',
    'bicycle',
    'billing',
    'bingo',
    'biography',
    'biology',
    'birthplace',
    'blackberry',
    'blather',
    'blossom',
    'boardroom',
    'boasting',
    'bodyguard',
    'boldness',
    'bomber',
    'bondage',
    'bonding',
    'bones',
    'bonus',
    'bookmark',
    'boomer',
    'booty',
    'bounds',
    'bowling',
    'brainstorming',
    'breadth',
    'breaker',
    'brewer',
    'brightness',
    'broccoli',
    'broth',
    'brotherhood',
    'browsing',
    'brunch',
    'brunt',
    'building',
    'bullion',
    'bureaucracy',
    'burglary',
    'buyout',
    'cabal',
    'cabbage',
    'calamity',
    'campaign',
    'canonization',
    'captaincy',
    'carcass',
    'carrier',
    'cartridge',
    'cassette',
    'catfish',
    'caught',
    'celebrity',
    'cemetery',
    'certainty',
    'certification',
    'charade',
    'chasm',
    'cheerleader',
    'cheesecake',
    'chemotherapy',
    'chili',
    'china',
    'chivalry',
    'cholera',
    'cilantro',
    'circus',
    'civilisation',
    'civility',
    'clearance',
    'clearing',
    'clerk',
    'climber',
    'closeness',
    'clothing',
    'clutches',
    'coaster',
    'coconut',
    'coding',
    'collaborator',
    'colleague',
    'college',
    'collision',
    'colors',
    'combustion',
    'comedian',
    'comer',
    'commander',
    'commemoration',
    'commenter',
    'commissioner',
    'commune',
    'competition',
    'completeness',
    'complexity',
    'computing',
    'comrade',
    'concur',
    'condominium',
    'conduit',
    'confidant',
    'configuration',
    'confiscation',
    'conflagration',
    'conflict',
    'consist',
    'consistency',
    'consolidation',
    'conspiracy',
    'constable',
    'consul',
    'consultancy',
    'contentment',
    'contents',
    'contractor',
    'conversation',
    'cornerstone',
    'corpus',
    'correlation',
    'councilman',
    'counselor',
    'countdown',
    'countryman',
    'coverage',
    'covering',
    'coyote',
    'cracker',
    'creator',
    'criminality',
    'crocodile',
    'cropping',
    'crossover',
    'crossroads',
    'culprit',
    'cumin',
    'curator',
    'curfew',
    'cursor',
    'custard',
    'cutter',
    'cyclist',
    'cyclone',
    'cylinder',
    'cynicism',
    'daddy',
    'damsel',
    'darkness',
    'dawning',
    'daybreak',
    'dealing',
    'dedication',
    'deduction',
    'defection',
    'deference',
    'deficiency',
    'definition',
    'deflation',
    'degeneration',
    'delegation',
    'delicacy',
    'delirium',
    'deliverance',
    'demeanor',
    'demon',
    'demonstration',
    'denomination',
    'dentist',
    'departure',
    'depletion',
    'depression',
    'designation',
    'despotism',
    'detention',
    'developer',
    'devolution',
    'dexterity',
    'diagnosis',
    'dialect',
    'differentiation',
    'digger',
    'digress',
    'dioxide',
    'diploma',
    'disability',
    'disarmament',
    'discord',
    'discovery',
    'dishonesty',
    'dismissal',
    'disobedience',
    'dispatcher',
    'disservice',
    'distribution',
    'distributor',
    'diver',
    'diversity',
    'docking',
    'dollar',
    'dominance',
    'domination',
    'dominion',
    'donkey',
    'doorstep',
    'doorway',
    'dossier',
    'downside',
    'drafting',
    'drank',
    'drilling',
    'driver',
    'drumming',
    'drunkenness',
    'duchess',
    'ducking',
    'dugout',
    'dumps',
    'dwelling',
    'dynamics',
    'eagerness',
    'earnestness',
    'earnings',
    'eater',
    'editor',
    'effectiveness',
    'electricity',
    'elements',
    'eloquence',
    'emancipation',
    'embodiment',
    'embroidery',
    'emperor',
    'employment',
    'encampment',
    'enclosure',
    'encouragement',
    'endangerment',
    'enlightenment',
    'enthusiasm',
    'environment',
    'environs',
    'envoy',
    'epilepsy',
    'equation',
    'equator',
    'error',
    'espionage',
    'estimation',
    'evacuation',
    'exaggeration',
    'examination',
    'exclamation',
    'expediency',
    'exploitation',
    'extinction',
    'eyewitness',
    'falls',
    'fascism',
    'fastball',
    'feces',
    'feedback',
    'ferocity',
    'fertilization',
    'fetish',
    'finale',
    'firing',
    'fixing',
    'flashing',
    'flask',
    'flora',
    'fluke',
    'folklore',
    'follower',
    'foothold',
    'footing',
    'forefinger',
    'forefront',
    'forgiveness',
    'formality',
    'formation',
    'formula',
    'foyer',
    'fragmentation',
    'framework',
    'fraud',
    'freestyle',
    'frequency',
    'friendliness',
    'fries',
    'frigate',
    'fulfillment',
    'function',
    'functionality',
    'fundraiser',
    'fusion',
    'futility',
    'gallantry',
    'gallery',
    'genesis',
    'genitals',
    'girlfriend',
    'glamour',
    'glitter',
    'glucose',
    'google',
    'grandeur',
    'grappling',
    'greens',
    'gridlock',
    'grocer',
    'groundwork',
    'grouping',
    'gunman',
    'gusto',
    'habitation',
    'hacker',
    'hallway',
    'hamburger',
    'hammock',
    'handling',
    'hands',
    'handshake',
    'happiness',
    'hardship',
    'headcount',
    'header',
    'headquarters',
    'heads',
    'headset',
    'hearth',
    'hearts',
    'heath',
    'hegemony',
    'height',
    'hello',
    'helper',
    'helping',
    'helplessness',
    'hierarchy',
    'hoarding',
    'hockey',
    'homeland',
    'homer',
    'honesty',
    'horror',
    'horseman',
    'hostility',
    'housing',
    'humility',
    'hurricane',
    'iceberg',
    'ignition',
    'illness',
    'illustration',
    'illustrator',
    'immunity',
    'immunization',
    'imperialism',
    'imprisonment',
    'inaccuracy',
    'inaction',
    'inactivity',
    'inauguration',
    'indecency',
    'indicator',
    'inevitability',
    'infamy',
    'infiltration',
    'influx',
    'iniquity',
    'innocence',
    'innovation',
    'insanity',
    'inspiration',
    'instruction',
    'instructor',
    'insurer',
    'interact',
    'intercession',
    'intercourse',
    'intermission',
    'interpretation',
    'intersection',
    'interval',
    'intolerance',
    'intruder',
    'invasion',
    'investment',
    'involvement',
    'irrigation',
    'iteration',
    'jenny',
    'jogging',
    'jones',
    'joseph',
    'juggernaut',
    'juncture',
    'jurisprudence',
    'juror',
    'kangaroo',
    'kingdom',
    'knocking',
    'laborer',
    'larceny',
    'laurels',
    'layout',
    'leadership',
    'leasing',
    'legislation',
    'leopard',
    'liberation',
    'licence',
    'lifeblood',
    'lifeline',
    'ligament',
    'lighting',
    'likeness',
    'lineage',
    'liner',
    'lineup',
    'liquidation',
    'listener',
    'literature',
    'litigation',
    'litre',
    'loathing',
    'locality',
    'lodging',
    'logic',
    'longevity',
    'lookout',
    'lordship',
    'lustre',
    "ma'am",
    'machinery',
    'madness',
    'magnificence',
    'mahogany',
    'mailing',
    'mainframe',
    'maintenance',
    'majority',
    'manga',
    'mango',
    'manifesto',
    'mantra',
    'manufacturer',
    'maple',
    'martin',
    'martyrdom',
    'mathematician',
    'matrix',
    'matron',
    'mayhem',
    'mayor',
    'means',
    'meantime',
    'measurement',
    'mechanics',
    'mediator',
    'medics',
    'melodrama',
    'memory',
    'mentality',
    'metaphysics',
    'method',
    'metre',
    'miner',
    'mirth',
    'misconception',
    'misery',
    'mishap',
    'misunderstanding',
    'mobility',
    'molasses',
    'momentum',
    'monarchy',
    'monument',
    'morale',
    'mortality',
    'motto',
    'mouthful',
    'mouthpiece',
    'mover',
    'movie',
    'mowing',
    'murderer',
    'musician',
    'mutation',
    'mythology',
    'narration',
    'narrator',
    'nationality',
    'negligence',
    'neighborhood',
    'neighbour',
    'nervousness',
    'networking',
    'nexus',
    'nightmare',
    'nobility',
    'nobody',
    'noodle',
    'normalcy',
    'notification',
    'nourishment',
    'novella',
    'nucleus',
    'nuisance',
    'nursery',
    'nutrition',
    'nylon',
    'oasis',
    'obscenity',
    'obscurity',
    'observer',
    'offense',
    'onslaught',
    'operation',
    'opportunity',
    'opposition',
    'oracle',
    'orchestra',
    'organisation',
    'organizer',
    'orientation',
    'originality',
    'ounce',
    'outage',
    'outcome',
    'outdoors',
    'outfield',
    'outing',
    'outpost',
    'outset',
    'overseer',
    'owner',
    'oxygen',
    'pairing',
    'panther',
    'paradox',
    'parliament',
    'parsley',
    'parson',
    'passenger',
    'pasta',
    'patchwork',
    'pathos',
    'patriotism',
    'pendulum',
    'penguin',
    'permission',
    'persona',
    'perusal',
    'pessimism',
    'peter',
    'philosopher',
    'phosphorus',
    'phrasing',
    'physique',
    'piles',
    'plateau',
    'playing',
    'plaza',
    'plethora',
    'plurality',
    'pneumonia',
    'pointer',
    'poker',
    'policeman',
    'polling',
    'poster',
    'posterity',
    'posting',
    'postponement',
    'potassium',
    'pottery',
    'poultry',
    'pounding',
    'pragmatism',
    'precedence',
    'precinct',
    'preoccupation',
    'pretense',
    'priesthood',
    'prisoner',
    'privacy',
    'probation',
    'proceeding',
    'proceedings',
    'processing',
    'processor',
    'progression',
    'projection',
    'prominence',
    'propensity',
    'prophecy',
    'prorogation',
    'prospectus',
    'protein',
    'prototype',
    'providence',
    'provider',
    'provocation',
    'proximity',
    'puberty',
    'publicist',
    'publicity',
    'publisher',
    'pundit',
    'putting',
    'quantity',
    'quart',
    'quilting',
    'quorum',
    'racism',
    'radiance',
    'ralph',
    'rancher',
    'ranger',
    'rapidity',
    'rapport',
    'ratification',
    'rationality',
    'reaction',
    'reader',
    'reassurance',
    'rebirth',
    'receptor',
    'recipe',
    'recognition',
    'recourse',
    'recreation',
    'rector',
    'recurrence',
    'redemption',
    'redistribution',
    'redundancy',
    'refinery',
    'reformer',
    'refrigerator',
    'regularity',
    'regulator',
    'reinforcement',
    'reins',
    'reinstatement',
    'relativism',
    'relaxation',
    'rendition',
    'repayment',
    'repentance',
    'repertoire',
    'repository',
    'republic',
    'reputation',
    'resentment',
    'residency',
    'resignation',
    'restaurant',
    'resurgence',
    'retailer',
    'retention',
    'retirement',
    'reviewer',
    'riches',
    'righteousness',
    'roadblock',
    'robber',
    'rocks',
    'rubbing',
    'runoff',
    'saloon',
    'salvation',
    'sarcasm',
    'saucer',
    'savior',
    'scarcity',
    'scenario',
    'scenery',
    'schism',
    'scholarship',
    'schoolboy',
    'schooner',
    'scissors',
    'scolding',
    'scooter',
    'scouring',
    'scrimmage',
    'scrum',
    'seating',
    'sediment',
    'seduction',
    'seeder',
    'seizure',
    'semicolon',
    'semiconductor',
    'semifinal',
    'senator',
    'sending',
    'serenity',
    'seriousness',
    'servitude',
    'sesame',
    'setup',
    'sewing',
    'sharpness',
    'shaving',
    'shoplifting',
    'shopping',
    'siding',
    'simplicity',
    'simulation',
    'sinking',
    'skate',
    'sloth',
    'slugger',
    'snack',
    'snail',
    'snapshot',
    'snark',
    'soccer',
    'solemnity',
    'solicitation',
    'solitude',
    'somewhere',
    'sophistication',
    'sorcery',
    'souvenir',
    'spaghetti',
    'specification',
    'specimen',
    'specs',
    'spectacle',
    'spectre',
    'speculation',
    'sperm',
    'spoiler',
    'squad',
    'squid',
    'staging',
    'stagnation',
    'staircase',
    'stairway',
    'stamina',
    'standpoint',
    'standstill',
    'stanza',
    'statement',
    'stillness',
    'stimulus',
    'stocks',
    'stole',
    'stoppage',
    'storey',
    'storyteller',
    'stylus',
    'subcommittee',
    'subscription',
    'subsidy',
    'suburb',
    'success',
    'sufferer',
    'supposition',
    'suspension',
    'sweater',
    'sweepstakes',
    'swimmer',
    'syndrome',
    'synopsis',
    'syntax',
    'system',
    'tablespoon',
    'taker',
    'tavern',
    'technology',
    'telephony',
    'template',
    'tempo',
    'tendency',
    'tendon',
    'terrier',
    'terror',
    'terry',
    'theater',
    'theology',
    'therapy',
    'thicket',
    'thoroughfare',
    'threshold',
    'thriller',
    'thunderstorm',
    'ticker',
    'tiger',
    'tights',
    'tossing',
    'touchdown',
    'tourist',
    'tourney',
    'toxicity',
    'tracing',
    'tractor',
    'translation',
    'transmission',
    'transmitter',
    'trauma',
    'traveler',
    'treadmill',
    'trilogy',
    'trout',
    'tuning',
    'twenties',
    'tycoon',
    'tyrant',
    'ultimatum',
    'underdog',
    'underwear',
    'unhappiness',
    'unification',
    'university',
    'uprising',
    'vaccination',
    'validity',
    'vampire',
    'vanguard',
    'variation',
    'vegetation',
    'verification',
    'viability',
    'vicinity',
    'victory',
    'viewpoint',
    'villa',
    'vindication',
    'violation',
    'vista',
    'vocalist',
    'vogue',
    'volcano',
    'voltage',
    'vomiting',
    'vulnerability',
    'waistcoat',
    'waitress',
    'wardrobe',
    'warmth',
    'watchdog',
    'wealth',
    'weariness',
    'whereabouts',
    'whisky',
    'whiteness',
    'widget',
    'width',
    'windfall',
    'wiring',
    'witchcraft',
    'withholding',
    'womanhood',
    'words',
    'workman',
    'youngster',
  ],
  "de": [
    'Rüstung',
    'Brecht',
    'Churchill',
    'Katholizismus',
    'Chihuahua',
    'Christentum',
    'Ostern',
    'Franzose',
    'Luther',
    'Mozart',
    'Orientalismus',
    'Pharao',
    'Planck',
    'Picasso',
    'Rodeo',
    'Samstag',
    'Schwester',
    'Shakespeare',
    'Sinatra',
    'Dienstag',
    'Wallraff',
    'Abtei',
    'Abwesenheit',
    'Aufnahme',
    'Abstinenz',
    'Absurdität',
    'Reichtum',
    'Akzeptanz',
    'Zugänglichkeit',
    'Unterkunft',
    'Komplize',
    'Verantwortung',
    'Buchhaltung',
    'Akkreditierung',
    'Genauigkeit',
    'Duldung',
    'Anbaufläche',
    'Schauspielerin',
    'Aktualität',
    'Sprichwort',
    'Anpassung',
    'Anhaftend',
    'Angleichung',
    'Adoption',
    'Ehebruch',
    'Beförderung',
    'Hinweis',
    'Reklame',
    'Werbung',
    'Ratschlag',
    'Ästhetik',
    'Affinität',
    'Aggression',
    'Landwirtschaft',
    'Flugzeug',
    'Flugzeit',
    'Behauptung',
    'Treue',
    'Anspielung',
    'Allergie',
    'Verbündete',
    'Alligator',
    'Zuteilung',
    'Zuweisung',
    'Streit',
    'Krankenwagen',
    'Ammoniak',
    'Anatomie',
    'Anämie',
    'Knöchel',
    'Ankündigung',
    'Ärgernis',
    'Anomalie',
    'Anthropologie',
    'Beunruhigung',
    'Apartheid',
    'entschuldigen',
    'Apostel',
    'Apparat',
    'Beschwichtigung',
    'Anrufung',
    'Anhang',
    'Beifall',
    'Ernennung',
    'Lobpreisung',
    'Bogenschießen',
    'Archipel',
    'Architektur',
    'Inbrunst',
    'Rückstände',
    'Pfeil',
    'Kunsthandwerk',
    'Kunstfertigkeit',
    'Aufstieg',
    'Montage',
    'Auftrag',
    'Verein',
    'Asthma',
    'Atheismus',
    'Angreifer',
    'Anziehung',
    'Anziehungskraft',
    'Aussichten',
    'Autorität',
    'Geiz',
    'Abneigung',
    'Luftfahrt',
    'Geplapper',
    'Gegenreaktion',
    'Bäcker',
    'Ballett',
    'Bälle',
    'Banjo',
    'Baron',
    'Schranke',
    'Anwalt',
    'Basen',
    'Waschbecken',
    'Basis',
    'Batterie',
    'Kämpfen',
    'Bettzeit',
    'Anfänger',
    'begonnen',
    'Biegen',
    'Fahrrad',
    'Abrechnung',
    'Bingo',
    'Biographie',
    'Biologie',
    'Geburtsort',
    'Brombeere',
    'Geschwätz',
    'Blüte',
    'Sitzungssaal',
    'Prahlerei',
    'Leibwächter',
    'Kühnheit',
    'Bombenleger',
    'fesseln',
    'Bindung',
    'Knochen',
    'Bonus',
    'Lesezeichen',
    'Boomer',
    'Beute',
    'Grenzen',
    'Bowling',
    'Brainstorming',
    'Umfang',
    'unterbrechen',
    'Bierbrauer',
    'Helligkeit',
    'Brokkoli',
    'Brühe',
    'Bruderschaft',
    'stöbern',
    'Brunch',
    'brunchen',
    'Gebäude',
    'Barren',
    'Bürokratie',
    'Einbruch',
    'Auskauf',
    'Kabale',
    'Kraut',
    'Desaster',
    'Kampagne',
    'Heiligsprechung',
    'Kapitän',
    'Kadaver',
    'Träger',
    'Kassette',
    'Kartusche',
    'Wels',
    'gefangen',
    'Berühmtheit',
    'Friedhof',
    'Gewissheit',
    'Zertifizierung',
    'Scharade',
    'Abgrund',
    'Cheerleader',
    'Käsekuchen',
    'Chemotherapie',
    'Chili',
    'Porzellan',
    'Ritter',
    'Cholera',
    'Koriander',
    'Zirkus',
    'Zivilisation',
    'Höflichkeit',
    'Räumung',
    'Klärung',
    'Angestellter',
    'Bergsteiger',
    'Enge',
    'Kleidung',
    'umklammern',
    'Untersetzer',
    'Kokosnuss',
    'Kodierung',
    'Mitarbeiter',
    'Kollege',
    'Hochschule',
    'Kollision',
    'Farben',
    'Verbrennung',
    'Comedian',
    'Komiker',
    'Kommandeur',
    'Gedenkfeier',
    'Kommentator',
    'Kommissar',
    'Kommune',
    'Wettbewerb',
    'Ganzheit',
    'Komplexität',
    'Genosse',
    'übereinstimmen',
    'Leitung',
    'Vertrauter',
    'Konfiguration',
    'konfiszieren',
    'Feuersbrunst',
    'Konflikt',
    'bestehen',
    'Konsistenz',
    'Konsolidierung',
    'Verschwörung',
    'Wachtmeister',
    'Konsul',
    'Beratung',
    'Inhalt',
    'Auftragnehmer',
    'Gespräch',
    'Eckpfeiler',
    'Korpus',
    'Korrelation',
    'Stadtrat',
    'Berater',
    'Countdown',
    'Landmann',
    'Abdeckung',
    'Kojote',
    'Cracker',
    'Schöpfer',
    'Kriminalität',
    'Krokodil',
    'beschneiden',
    'Kreuzweg',
    'Abzweigung',
    'Übeltäter',
    'Kreuzkümmel',
    'Kurator',
    'Sperrstunde',
    'Cursor',
    'Pudding',
    'Kutter',
    'Radfahrer',
    'Zyklon',
    'Zylinder',
    'Zynismus',
    'Papa',
    'Jungfrau',
    'Dunkelheit',
    'Dämmerung',
    'Tagesanbruch',
    'Deal',
    'Hingabe',
    'Abzug',
    'Ablehnung',
    'Ehrerbietung',
    'Mangel',
    'Definition',
    'Deflation',
    'Degeneration',
    'Delegation',
    'Delikatesse',
    'Delirium',
    'Erlösung',
    'Benehmen',
    'Dämon',
    'Vorführung',
    'Konfession',
    'Zahnarzt',
    'Abreise',
    'Erschöpfung',
    'Depression',
    'Bezeichnung',
    'Willkür',
    'Inhaftierung',
    'Entwickler',
    'Entfaltung',
    'Geschick',
    'Diagnose',
    'Dialekt',
    'Differenzierung',
    'Bagger',
    'abschweifen',
    'Dioxid',
    'Diplom',
    'Behinderung',
    'Abrüstung',
    'Zwietracht',
    'Entdeckung',
    'Unehrlichkeit',
    'Entlassung',
    'Ungehorsam',
    'Verteiler',
    'Vertrieb',
    'Lieferant',
    'Taucher',
    'Vielfalt',
    'andocken',
    'Dollar',
    'Dominanz',
    'Vorherrschaft',
    'Herrscher',
    'Esel',
    'Türschwelle',
    'Eingang',
    'Dossier',
    'Nachteil',
    'Ausarbeitung',
    'Trank',
    'Bohren',
    'Fahrer',
    'trommeln',
    'Trunkenheit',
    'Herzogin',
    'ducken',
    'Unterstand',
    'Müllhalde',
    'Heim',
    'Dynamik',
    'Eifer',
    'Ernst',
    'Verdienst',
    'Esser',
    'Herausgeber',
    'Wirksamkeit',
    'Strom',
    'Elemente',
    'Beredsamkeit',
    'Emanzipation',
    'Verkörperung',
    'Stickerei',
    'Kaiser',
    'Beschäftigung',
    'Lager',
    'Gehege',
    'Ermutigung',
    'Gefährdung',
    'Aufklärung',
    'Begeisterung',
    'Umwelt',
    'Umfeld',
    'Gesandter',
    'Epilepsie',
    'Gleichung',
    'Äquator',
    'Fehler',
    'Spionage',
    'Schätzung',
    'Evakuierung',
    'Übertreibung',
    'Prüfung',
    'Ausruf',
    'Zweckmäßigkeit',
    'Ausbeutung',
    'Auslöschung',
    'Augenzeuge',
    'fällt',
    'Faschismus',
    'Elfer',
    'Fäkalien',
    'Rückmeldung',
    'Wildheit',
    'Befruchtung',
    'Fetisch',
    'Finale',
    'brennen',
    'Befestigung',
    'Aufblitzen',
    'Flachmann',
    'flora',
    'Flanke',
    'Folklore',
    'Mitläufer',
    'Fußstapfen',
    'Fußstellung',
    'Zeigefinger',
    'Vorderseite',
    'Verzeihung',
    'Förmlichkeit',
    'Bildung',
    'Formel',
    'Foyer',
    'Fragmentierung',
    'Rahmen',
    'Betrug',
    'Freestyle',
    'Häufigkeit',
    'Freundlichkeit',
    'Pommes',
    'Fregatte',
    'Erfüllung',
    'Funktion',
    'Funktionalität',
    'Spendenaktion',
    'Fusion',
    'Vergeblichkeit',
    'Galanterie',
    'Galerie',
    'Genesis',
    'Genitalien',
    'Freundin',
    'Glamour',
    'Glitzer',
    'Glukose',
    'Google',
    'Erhabenheit',
    'packen',
    'Gemüse',
    'Stau',
    'Vorarbeit',
    'Gruppierung',
    'Schütze',
    'Gusto',
    'Wohnen',
    'Hacker',
    'Korridor',
    'Hamburger',
    'Hängematte',
    'Handhabung',
    'Hände',
    'Händedruck',
    'Glück',
    'Härtefall',
    'Personalstand',
    'Kopfzeile',
    'Hauptsitz',
    'Köpfe',
    'Kopfhörer',
    'Herd',
    'Herzen',
    'Heide',
    'Hegemonie',
    'Höhe',
    'hallo',
    'Helfer',
    'hilfreich',
    'Hilflosigkeit',
    'Hierarchie',
    'Hamstern',
    'Eishockey',
    'Heimat',
    'Homer',
    'Ehrlichkeit',
    'Horror',
    'Reiter',
    'Feindseligkeit',
    'Gehäuse',
    'Bescheidenheit',
    'Wirbelsturm',
    'Eisberg',
    'Zündung',
    'Krankheit',
    'Illustration',
    'Illustrator',
    'Immunität',
    'Immunisierung',
    'Imperialismus',
    'Verhaftung',
    'Ungenauigkeit',
    'Untätigkeit',
    'Inaktivität',
    'Einweihung',
    'Unanständigkeit',
    'Indikator',
    'Infamie',
    'Infiltration',
    'Zustrom',
    'Ungerechtigkeit',
    'Unschuld',
    'Neuerung',
    'Inspiration',
    'Unterricht',
    'Ausbilder',
    'Versicherung',
    'interagieren',
    'Vermittlung',
    'Verkehr',
    'Unterbrechung',
    'Auslegung',
    'Kreuzung',
    'Pause',
    'Intoleranz',
    'Eindringling',
    'Invasion',
    'Investition',
    'Beteiligung',
    'Bewässerung',
    'Wiederholung',
    'Jenny',
    'joggen',
    'Jonas',
    'Joseph',
    'Lastwagen',
    'Knotenpunkt',
    'Rechtsprechung',
    'Schöffen',
    'Känguru',
    'Königreich',
    'Klopfen',
    'Arbeiter',
    'Diebstahl',
    'Lorbeeren',
    'Layout',
    'Führung',
    'Leasing',
    'Gesetzgebung',
    'Leopard',
    'Befreiung',
    'Lizenz',
    'Herzblut',
    'Lebensader',
    'Ligament',
    'Beleuchtung',
    'Abbild',
    'Abstammung',
    'Linie',
    'Aufstellung',
    'Liquidierung',
    'Hörer',
    'Literatur',
    'Rechtsstreit',
    'Liter',
    'Abscheu',
    'Ortschaft',
    'Gästehaus',
    'Logik',
    'Langlebigkeit',
    'Ausschau',
    'Herrschaft',
    'Glanz',
    'Maschinenpark',
    'Wahnsinn',
    'Pracht',
    'Mahagoni',
    'Post',
    'Großrechner',
    'Wartung',
    'Mehrheit',
    'Manga',
    'Mango',
    'Manifest',
    'Mantra',
    'Hersteller',
    'Ahorn',
    'Martin',
    'Martyrium',
    'Mathematiker',
    'Matrix',
    'Matrose',
    'Chaos',
    'Bürgermeister',
    'Mittel',
    'Zwischenzeit',
    'Messung',
    'Mechaniker',
    'Vermittler',
    'Mediziner',
    'Melodrama',
    'Gedächtnis',
    'Mentalität',
    'Metaphysik',
    'Methode',
    'Metrum',
    'Bergmann',
    'Fröhlichkeit',
    'Irrtum',
    'Elend',
    'Missgeschick',
    'Missverständnis',
    'Mobilität',
    'Melasse',
    'Schwung',
    'Monarchie',
    'Denkmal',
    'Moral',
    'Sterblichkeit',
    'Motto',
    'Mundvoll',
    'Mundstück',
    'Beweger',
    'Film',
    'Mähen',
    'Mörder',
    'Musiker',
    'Mutation',
    'Mythologie',
    'Erzählung',
    'Erzähler',
    'Nationalität',
    'Nachlässigkeit',
    'Nachbarschaft',
    'Nachbar',
    'Nervosität',
    'Vernetzung',
    'Verknüpfung',
    'Alptraum',
    'Adel',
    'Niemand',
    'Nudel',
    'Normalität',
    'Meldung',
    'Ernährung',
    'Novelle',
    'Keim',
    'Belästigung',
    'Gärtnerei',
    'Nahrung',
    'Nylon',
    'Oase',
    'Obszönität',
    'Unklarheit',
    'Beobachter',
    'Beleidigung',
    'Ansturm',
    'Operation',
    'Gelegenheit',
    'Opposition',
    'Orakel',
    'Orchester',
    'Organisation',
    'Veranstalter',
    'Orientierung',
    'Originalität',
    'Unze',
    'Ausfall',
    'Ergebnis',
    'Outdoor',
    'Außenbereich',
    'Outing',
    'Außenposten',
    'Anfang',
    'Aufpasser',
    'Besitzer',
    'Sauerstoff',
    'Paarung',
    'Panther',
    'Paradox',
    'Parlament',
    'Petersilie',
    'Pfarrer',
    'Passagier',
    'Nudeln',
    'Patchwork',
    'Pathos',
    'Patriotismus',
    'Pendel',
    'Pinguin',
    'Erlaubnis',
    'Person',
    'Durchsicht',
    'Pessimismus',
    'Peter',
    'Philosoph',
    'Phosphor',
    'Formulierung',
    'Körperbau',
    'Haufen',
    'Plateau',
    'Spielen',
    'Platz',
    'Fülle',
    'Vielzahl',
    'Zeiger',
    'Poker',
    'Polizist',
    'Umfrage',
    'Poster',
    'Nachwelt',
    'Aushang',
    'Aufschub',
    'Kalium',
    'Töpferei',
    'Geflügel',
    'Hämmern',
    'Pragmatismus',
    'Vorrang',
    'Revier',
    'Besorgnis',
    'Vortäuschung',
    'Priesterschaft',
    'Gefangener',
    'Privatsphäre',
    'Bewährung',
    'Prozess',
    'Verfahren',
    'Bearbeitung',
    'Bearbeiter',
    'Verlauf',
    'Projektion',
    'Prominenz',
    'Neigung',
    'Prophezeiung',
    'Vertagung',
    'Prospekte',
    'Eiweiß',
    'Prototyp',
    'Vorsehung',
    'Anbieter',
    'Provokation',
    'Nähe',
    'Pubertät',
    'Publizist',
    'Verlag',
    'Fachmann',
    'Setzen',
    'Menge',
    'Quart',
    'steppen',
    'Quorum',
    'Rassismus',
    'Ausstrahlung',
    'Ralf',
    'Ranch',
    'Ranger',
    'Schnelligkeit',
    'Rapport',
    'Ratifizierung',
    'Rationalität',
    'Reaktion',
    'Leser',
    'Beruhigung',
    'Wiedergeburt',
    'Rezeptor',
    'Rezept',
    'Anerkennung',
    'Rückgriff',
    'Erholung',
    'Rektor',
    'Auftreten',
    'Rücknahme',
    'Umverteilung',
    'Redundanz',
    'Raffinerie',
    'Reformer',
    'Kühlschrank',
    'Regelmäßigkeit',
    'Regler',
    'Verstärkung',
    'Zügel',
    'Relativismus',
    'Entspannung',
    'Wiedergabe',
    'Rückzahlung',
    'Reue',
    'Repertoire',
    'Republik',
    'Ruf',
    'Ressentiment',
    'Wohnsitz',
    'Rücktritt',
    'Restaurant',
    'Wiederaufleben',
    'Einzelhändler',
    'Beibehaltung',
    'Ruhestand',
    'Rezensent',
    'Reichtümer',
    'Straßensperre',
    'Räuber',
    'Felsen',
    'Reiben',
    'Abfluss',
    'Saloon',
    'Rettung',
    'Sarkasmus',
    'Untertasse',
    'Retter',
    'Knappheit',
    'Szenario',
    'Szene',
    'Schisma',
    'Stipendium',
    'Schüler',
    'Schoner',
    'Schere',
    'Schelte',
    'Motorroller',
    'Scheuern',
    'Gedränge',
    'Tumult',
    'Sitzen',
    'Sediment',
    'Verführung',
    'Sämaschine',
    'Beschlagnahme',
    'Semikolon',
    'Halbleiter',
    'Halbfinale',
    'Senator',
    'Senden',
    'Gelassenheit',
    'Ernsthaftigkeit',
    'Knechtschaft',
    'Sesam',
    'Einrichten',
    'Nähmaschine',
    'Schärfe',
    'Rasur',
    'Ladendiebstahl',
    'Einkaufen',
    'Abstellgleis',
    'Einfachheit',
    'Simulation',
    'Sinken',
    'Skateboard',
    'Faultier',
    'Schläger',
    'Snack',
    'Schnecke',
    'Schnappschuss',
    'Kritik',
    'Fußball',
    'Feierlichkeit',
    'Aufforderung',
    'Einsamkeit',
    'irgendwo',
    'Raffinesse',
    'Zauberei',
    'Souvenir',
    'Spaghetti',
    'Spezifikation',
    'Muster',
    'Exemplar',
    'Spektakel',
    'Gespenst',
    'Spekulation',
    'Sperma',
    'Spoiler',
    'Kader',
    'Tintenfisch',
    'Inszenierung',
    'Stagnation',
    'Stufe',
    'Treppe',
    'Standpunkt',
    'Stillstand',
    'Strophe',
    'Aussage',
    'Stille',
    'Anregung',
    'Aktien',
    'gestohlen',
    'Einhalt',
    'Stockwerk',
    'Griffel',
    'Unterausschuss',
    'Abonnement',
    'Subvention',
    'Vorort',
    'Erfolg',
    'Leidtragender',
    'Vermutung',
    'Aussetzung',
    'Pullover',
    'Gewinnspiel',
    'Schwimmer',
    'Syndrom',
    'Zusammenfassung',
    'Syntax',
    'System',
    'Esslöffel',
    'Abnehmer',
    'Kneipe',
    'Technologie',
    'Telefonie',
    'Vorlage',
    'Tempo',
    'Tendenz',
    'Sehne',
    'Terrier',
    'Terror',
    'Teddy',
    'Theater',
    'Theologie',
    'Therapie',
    'Dickicht',
    'Schwelle',
    'Krimi',
    'Gewitter',
    'Ticker',
    'Tiger',
    'Strumpfhose',
    'Wurf',
    'Touchdown',
    'Tourist',
    'Turnier',
    'Toxizität',
    'Rückverfolgung',
    'Traktor',
    'Übersetzung',
    'Übertragung',
    'Sender',
    'Trauma',
    'Reisende',
    'Tretmühle',
    'Trilogie',
    'Forelle',
    'Tuning',
    'Zwanziger',
    'Tycoon',
    'Tyrann',
    'Ultimatum',
    'Außenseiter',
    'Unterwäsche',
    'unglücklich',
    'Einigung',
    'Universität',
    'Aufstand',
    'Impfung',
    'Gültigkeit',
    'Vampir',
    'Vorhut',
    'Veränderung',
    'Vegetation',
    'Überprüfung',
    'Lebensfähigkeit',
    'Umgebung',
    'Sieg',
    'Aussichtspunkt',
    'Villa',
    'Rechtfertigung',
    'Verstoß',
    'Ausblick',
    'Vokalist',
    'vogue',
    'Vulkan',
    'Spannung',
    'Erbrechen',
    'Verwundbarkeit',
    'Weste',
    'Kellnerin',
    'Kleiderschrank',
    'Wärme',
    'Wachhund',
    'Wohlstand',
    'Müdigkeit',
    'Aufenthaltsort',
    'Whisky',
    'Weiße',
    'Widget',
    'Breite',
    'Geldsegen',
    'Verkabelung',
    'Hexerei',
    'Zurückhaltung',
    'Weiblichkeit',
    'Worte',
    'Handwerker',
    'Jugendlicher',
  ],
};

export default nouns;
